import {Component, Emit, Model, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class InputMixin extends Vue {
  protected value: any | null = null;

  @Model('change') protected model!: any;

  @Prop({type: Boolean, default: true}) protected clearable!: boolean;
  @Prop(String) protected label?: string;
  @Prop(String) protected placeholderText?: string;
  @Prop(String) protected error!: string;
  @Prop({type: Boolean, default: false}) protected disabled!: boolean;

  @Prop({type: Boolean, default: false}) protected autoFocus!: boolean;

  protected focus: boolean = false;

  get isFilled(): boolean {
    return (this.value !== null ? this.value.toString().length > 0 : false);
  }

  get up(): boolean {
    return this.focus || this.isFilled;
  }

  get isClearable(): boolean {
    return this.clearable && this.isFilled;
  }

  protected clear() {
    this.value = null;
    this.$emit('clear');
  }

  @Watch('model', {immediate: true})
  protected onModelChange(value: any | null) {
    this.value = value;
  }

  @Watch('value')
  @Emit('change')
  protected onValueChange(value: any | null) {
    return this.isFilled ? value : null;
  }

  private input() {
    this.$emit('input', this.value);
  }

  @Watch('focus')
  private onFocusChange() {
    if (this.focus) {
      this.$emit('focus');
    } else {
      this.$emit('blur');
    }
  }
}
